import React, { useState } from 'react'
import Translate, { useTranslate } from '../Translate/Translate'
import deleteIcon from '../../Images/Header/delete.svg'
import closeOpen from '../../Images/close_openCloseTool.png'
import './Concat.css'


const Concat = () => {

    const [deleteShow,setDeleteShow]=useState('show');
    const [openShow,setOpenShow]=useState('hide');
    const [floatMenu,setFloatMenu]=useState('floatMenuOut show');
    const [isAuto,setIsAuto]=useState(false);
    const [mainClass,setMainClass]=useState(" "+isAuto?"float-subjects":"float-subjects autoSizeFS")

    const handleClose=(e)=>{
        let deleteShowClass=deleteShow=="show"?"hide":"show"
        setDeleteShow(deleteShowClass);
        setOpenShow(openShow=="show"?"hide":"show");
        setFloatMenu('floatMenuOut '+deleteShowClass)
        setIsAuto(!isAuto);
        setMainClass(isAuto?"float-subjects":"float-subjects autoSizeFS");
      
    }
  return (
    <div className={mainClass} >

        <a className="float-subjects-close-button " href="javascript:void(0);" onClick={handleClose} aria-label={useTranslate(isAuto?"OpenFloatMenu":"CloseFloatMenu")}>
            <img src={deleteIcon} alt="close" className={deleteShow}/>
            <img src={closeOpen} alt="open" className={openShow}/>
        </a>
        <div className={floatMenu}>
            <h3 className="psFloatingMenuTitle"><Translate>NotFoundDataSet</Translate></h3>
            <div className="floatMenuMain">
                <div className="floatMenu-item">
                    
                    <a className="floatMenu-link"  href="mailto:tlvopendata@tel-aviv.gov.il" target="_blank"><Translate>WriteUS</Translate></a>

                </div>
            </div>
        </div>
    </div>

  )
}

export default Concat